import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addSongAction } from "../../action/songs";
import ApiService from "../../services/api-service";
import "./index.scss";

const artistName = (song) =>
  song.displayArtistName ||
  song.artist ||
  song.artistData?.[0]?.displayArtistName ||
  song.artistData?.[0]?.fullName ||
  "Unknown";

/**
 * Trending chart strip on the home page: the most-played songs of the last
 * 30 days, set like a chart listing. Scrolls slowly; pauses on hover or focus.
 */
const TrendingTicker = () => {
  const dispatch = useDispatch();
  const [songs, setSongs] = useState([]);

  useEffect(() => {
    let cancelled = false;
    ApiService.MUSIC_TRENDING_TICKER()
      .then((response) => {
        if (!cancelled && Array.isArray(response?.result)) setSongs(response.result);
      })
      .catch((error) => console.error("[TrendingTicker] failed to load trending songs", error));
    return () => { cancelled = true; };
  }, []);

  if (songs.length === 0) return null;

  const play = (song) => {
    if (!song.fileId?.filePath) {
      console.warn("[TrendingTicker] song has no audio file", { songId: song._id });
      return;
    }
    dispatch(addSongAction(song));
  };

  return (
    <section className="trending-chart" aria-label="Trending in the last 30 days">
      <h2 className="trending-chart__label">
        Trending<span>30 days</span>
      </h2>
      <div className="trending-chart__viewport">
        {/* Two copies back to back so the scroll loops without a seam. */}
        <ol className="trending-chart__list" style={{ animationDuration: `${songs.length * 6}s` }}>
          {[0, 1].map((copy) =>
            songs.map((song, i) => (
              <li key={`${copy}-${song._id || i}`} aria-hidden={copy === 1 || undefined}>
                <button
                  type="button"
                  className="trending-chart__entry"
                  tabIndex={copy === 1 ? -1 : undefined}
                  onClick={() => play(song)}
                >
                  <span className="trending-chart__rank">{String(i + 1).padStart(2, "0")}</span>
                  {song.thumbnailImg?.filePath && (
                    <img
                      className="trending-chart__cover"
                      src={song.thumbnailImg.filePath}
                      alt=""
                      loading="lazy"
                      draggable={false}
                    />
                  )}
                  <span className="trending-chart__title">{song.title}</span>
                  <span className="trending-chart__artist">{artistName(song)}</span>
                  {Number(song.recentStreams) > 0 && (
                    <span className="trending-chart__plays">+{Number(song.recentStreams).toLocaleString()}</span>
                  )}
                </button>
              </li>
            ))
          )}
        </ol>
      </div>
    </section>
  );
};

export default TrendingTicker;
